import React from "react";
import { useSelector } from "react-redux";
import {
  selectBody,
  selectFooter,
  selectHeader,
  selectOpen,
} from "../../panelSlice";
import Factory from "../Factory";
import "./Panel.scss";

const Panel = ({ children }) => {
  const open = useSelector(selectOpen);
  const header = useSelector(selectHeader);
  const body = useSelector(selectBody);
  const footer = useSelector(selectFooter);

  return (
    <div className={`Panel${open ? " open" : ""}`}>
      {!!header?.length && (
        <div className="PanelHeader">
          {header.map((item, index) => (
            <Factory key={index} {...item} />
          ))}
        </div>
      )}
      {!!body?.length && (
        <div className="PanelBody">
          {body.map((item, index) => (
            <Factory key={index} {...item} />
          ))}
        </div>
      )}
      {!!footer?.length && (
        <div className="PanelFooter">
          {footer.map((item, index) => (
            <Factory key={index} {...item} />
          ))}
        </div>
      )}
      {children}
    </div>
  );
};

export default Panel;
